import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { TARIFF_PLANS, TARIFF_PLANS_INFO } from '../../constants';
import s from './index.module.scss';

export const LoanPlans = ({ plan }) => {
  const { t } = useTranslation('plans-v5');
  return (
    <div className={s.wrapper}>
      <div className={classnames(s.desc, 'f-body-regular')}>
        {t('plans.each_company_assigned_risk_factor')}
      </div>
      <div className={s.desc}>{t('plans.risk_factor_defines_loan_plans')}</div>
      <div className={s.cards}>
        {Object.keys(TARIFF_PLANS).map(id => (
          <MyLink
            className={classnames(s.link, plan === id && s.link_active, 'f-paragraph-accent')}
            key={id}
            href={APP_LINKS.loanTermsPlans('', id)}
          >
            {TARIFF_PLANS_INFO[id].label}
          </MyLink>
        ))}
      </div>
    </div>
  );
};
